module.exports = __webpack_public_path__ + "img/check.8d9c04ef.svg";